module.exports = __webpack_public_path__ + "f6b4e15d.png";


//////////////////
// WEBPACK FOOTER
// ./public/icons/003-folder.png
// module id = 1468
// module chunks = 4